
import { useEffect, useMemo, useState } from "react";
import { getSearchTopSale, IProduct } from "../server/product";
import { cleanUrl } from "../contants";

export default function BannerList() {
  const [banners, setBanners] = useState<IProduct[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getSearchTopSale();
        if (res) setBanners(res);
      } catch (error) {
        console.error("Error loading banners:", error);
      }
    };
    load();
  }, []);

  const list = useMemo(
    () => banners?.filter((b) => b?.image).slice(0, 3),
    [banners]
  );

  return (
    <div className="grid gap-4">
      {list?.map((item, index) => (
        <a
          key={index}
          href={`/chi-tiet-san-pham/${item?.id}`}
          className="banner-spotlight group relative flex h-[130px] min-h-[120px] items-stretch overflow-hidden rounded-2xl border border-white/15 bg-white/10 shadow-xl transition hover:-translate-y-1"
        >
          <img
            src={cleanUrl(item.image || "") || "/no-image.jpg"}
            alt={item?.productName ?? ""}
            className="absolute inset-0 z-0 h-full w-full object-cover transition duration-500 group-hover:scale-105"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/no-image.jpg";
            }}
          />
          <div className="absolute inset-0 z-10 bg-gradient-to-t from-slate-900/60 via-slate-900/25 to-transparent opacity-70 transition group-hover:opacity-80" />
          <div className="relative z-20 flex h-full items-end justify-between px-4 pb-3">
            <p className="text-xs font-semibold text-white line-clamp-2 sm:text-sm">
              {item?.productName}
            </p>
            
          </div>
        </a>
      ))}
    </div>
  );
}
